import { render, staticRenderFns } from "./InfoTwoSvg.vue?vue&type=template&id=6c39816c&scoped=true"
import script from "./InfoTwoSvg.vue?vue&type=script&lang=js"
export * from "./InfoTwoSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c39816c",
  null
  
)

export default component.exports